import './bandsByCategory.scss';
import { useMemo } from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { categorizeBandsByParticipation, sortCategoriesByYear, getCategoryDisplayName } from '../../utils/bandCategorization';

/**
 * Komponente zur Anzeige von Bands kategorisiert nach ihrer Teilnahmehistorie
 */
export default function BandsByCategory({ bandData, path = '/bands', showNewBands = true }) {
    const categorizedBands = useMemo(() => {
        if (!bandData.length) return [];
        const sortedCategories = sortCategoriesByYear(categorizeBandsByParticipation(bandData));

        if (showNewBands) {
            return sortedCategories;
        }

        const years = sortedCategories
            .map(([category]) => parseInt(category.match(/\d{4}/)?.[0] || 0, 10))
            .filter((year) => year > 0);

        const latestYear = years.length ? Math.max(...years) : null;
        if (!latestYear) {
            return sortedCategories;
        }

        return sortedCategories.filter(([category]) => {
            const categoryYear = parseInt(category.match(/\d{4}/)?.[0] || 0, 10);
            return categoryYear !== latestYear;
        });
    }, [bandData, showNewBands]);

    if (!bandData.length) {
        return <div className="bandsCategoryContainer">Keine Bands vorhanden.</div>;
    }

    return (
        <div className="bandsCategoryContainer">
            {categorizedBands.map(([category, bands], idx) => {
                // Extrahiere Jahr aus Kategorie
                const yearMatch = category.match(/\d{4}/);
                if (!yearMatch) {
                    return category;
                }

                return (

                    <div key={idx} className="categorySection">
                        <h2 className="categoryTitle">{getCategoryDisplayName(category)}</h2>
                        <ul className="bandsList">
                            {bands.map((bandRaw, i) => {
                                const band = bandRaw.attributes;
                                const bandURL = `${path}${band.rigUrl}#bandbox`;
                                const image = band?.image?.data?.attributes?.formats?.medium?.url ?? band?.image?.data?.attributes?.url;
                                return (
                                    <li key={bandRaw.id} className="bandItem">
                                        <Link to={bandURL} className="bandLink">
                                            <div className="bandText">
                                                <span className="bandName">{band.name}</span><br />
                                                <span className="bandGenre">{band.genre}</span>
                                            </div>
                                            {image && <img className='bandPicture' src={image} alt={band.name + '- Bandimage'} />}
                                        </Link>
                                    </li>
                                );
                            })}
                        </ul>
                    </div>
                )
            })}
        </div>
    );
}
